/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { EuiButtonSize, EuiButtonColor } from '@elastic/eui'

import type { DeploymentSearchResponse, DeploymentGetResponse } from '@modules/cloud-api/v1/types'
import type { SliderInstanceType } from '@modules/ui-types'
import Feature from '@modules/utils/feature'

import { isFeatureActivated } from '../../../selectors'

import RetryStackDeploymentAttemptButton from './RetryStackDeploymentAttemptButton'

import type { ReduxState } from '@/types/redux'
import type { ReactNode } from 'react'

type StackDeployment = DeploymentSearchResponse | DeploymentGetResponse

type StateProps = {
  hideAdminReapplyButton?: boolean
}

interface DispatchProps {}

type ConsumerProps = {
  deployment: StackDeployment
  sliderInstanceType: SliderInstanceType
  disabled?: boolean
  children?: ReactNode
  size?: EuiButtonSize
  color?: EuiButtonColor
}

const mapStateToProps = (state: ReduxState): StateProps => ({
  hideAdminReapplyButton: isFeatureActivated(state, Feature.hideAdminReapplyButton),
})

const mapDispatchToProps: DispatchProps = {}

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(RetryStackDeploymentAttemptButton)
